'use strict';

angular.module('msWidgets').directive('msWidgetToolsUpload', [function () {
  return {
    templateUrl: 'widgets/templates/tools/upload.html'
  };
}]);